// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SourceModalController from "./source_modal_controller"
application.register("source-modal", SourceModalController)

import VisitTrackerController from "./visit_tracker_controller"
application.register("visit-tracker", VisitTrackerController)
